import { ArrowLeft } from "lucide-react";
import { useState } from "react";

import { useStudioApps } from "@/hooks/useStudioApps";

import { AppArtifactContainer } from "./AppArtifactContainer";
import { StudioWorldWindowUI } from "./StudioWorldWindow.ui";

interface StudioWorldWindowContainerProps {
  /** Deep-link to the full /studio page — the escape hatch for real work. */
  onOpenStudio: () => void;
}

/**
 * Data half of the Studio world window. Mounted only inside the chat
 * FloatingWindow when the computer prop is active, so `useStudioApps`'
 * fetch-on-mount fires only when the window is opened — never eagerly on the
 * chat route (NotebookQuickView precedent). Opening a row mounts the
 * `AppArtifactContainer`, whose `useStudioApp` lazily reads the full files.
 */
export function StudioWorldWindowContainer({ onOpenStudio }: StudioWorldWindowContainerProps) {
  const { apps, isLoading } = useStudioApps();
  const [openAppDir, setOpenAppDir] = useState<string | null>(null);

  if (openAppDir !== null) {
    return (
      <div className="flex h-full min-h-0 flex-col">
        <button
          type="button"
          onClick={() => setOpenAppDir(null)}
          className="mb-1.5 inline-flex w-fit shrink-0 items-center gap-1.5 rounded-full px-2 py-1 text-[12px] font-bold text-black/60 transition-colors hover:bg-black/5 hover:text-black dark:text-white/60 dark:hover:bg-white/10 dark:hover:text-white"
        >
          <ArrowLeft className="h-3.5 w-3.5" strokeWidth={2.4} />
          All apps
        </button>
        <div className="min-h-0 flex-1 overflow-hidden rounded-xl border border-black/8 dark:border-white/10">
          <AppArtifactContainer appDir={openAppDir} compact />
        </div>
      </div>
    );
  }

  return (
    <StudioWorldWindowUI
      apps={apps}
      isLoading={isLoading}
      onOpenApp={setOpenAppDir}
      onOpenStudio={onOpenStudio}
    />
  );
}
